import { render, staticRenderFns } from "./SwitchIcons.vue?vue&type=template&id=50ffd4b8&"
import script from "./SwitchIcons.vue?vue&type=script&lang=js&"
export * from "./SwitchIcons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports